import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Helper } from '../../common/helper';
import { DbContextService } from '../../../services/db-context.service';
import swal from 'sweetalert2';

declare var require: any
const objectHash = require('object-hash');

@Injectable({
  providedIn: 'root'
})
export class StocksOverviewService {

  constructor(
    private http: HttpClient,
    private dbxService: DbContextService) { }

  getShipBeginEndStockHeaderWithContractCurrencyList(departmentID: number, periodStart: string, periodEnd: string) {

    let parameter = `0/${departmentID}/${periodStart}/${periodEnd}`;

    return this.http.get(Helper.API_URL() + '/api/Budget/GetShipBeginEndStockHeaderWithContractCurrencyList/' + parameter);
  }

  getShipBeginEndStockTempData(shipID: number) {
    return this.http.get(Helper.API_URL() + '/api/Budget/GetShipBeginEndStockTempData/' + `${shipID}`);
  }

  deleteShipBeginEndStockTempData(headerID: string) {
    let paramObject = {
      'headerID': headerID
    }
    return this.http.post(Helper.API_URL() + '/api/Budget/DeleteShipBeginEndStockTempData', paramObject);
  }

  getShipBeginEndStockHeaderWithContractCurrencyListIntoIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let currentYear = new Date().getFullYear();
      let periodFrom = "1-1-" + (currentYear - 1);
      let periodTo = "12-31-" + currentYear;

      this.getShipBeginEndStockHeaderWithContractCurrencyList(Helper.Constants.DepartmentID.FOOD, periodFrom, periodTo).subscribe((food: any) => {
        if (food.errorMessage.length <= 0) {
          let foodList = food.entity.list;
          this.getShipBeginEndStockHeaderWithContractCurrencyList(Helper.Constants.DepartmentID.BONDED, periodFrom, periodTo).subscribe((bonded: any) => {
            if (bonded.errorMessage.length <= 0) {
              let bondedList = bonded.entity.list;
              this.getShipBeginEndStockHeaderWithContractCurrencyList(Helper.Constants.DepartmentID.CABIN, periodFrom, periodTo).subscribe((cabin: any) => {
                if (cabin.errorMessage.length <= 0) {
                  let cabinList = cabin.entity.list;

                  let submittedStockInfoOverviewList: any[] = [];
                  let closedStockInfoOverviewList: any[] = [];

                  let stockList = foodList.concat(bondedList, cabinList);
                  if (stockList != null) {
                    for (let i = 0; i < stockList.length; i++) {
                      switch (stockList[i].stockStatusID) {
                        case Helper.Constants.StockStatusID.NEW:
                        case Helper.Constants.StockStatusID.TO_BE_REVIEWED:
                        case Helper.Constants.StockStatusID.REVIEWED:
                          submittedStockInfoOverviewList.push(stockList[i]);
                          break;
                        case Helper.Constants.StockStatusID.ACCEPTED:
                        case Helper.Constants.StockStatusID.SYSTEM:
                          closedStockInfoOverviewList.push(stockList[i]);
                          break;
                      }
                    }
                  }

                  this.saveSubmittedStockIndexDb(submittedStockInfoOverviewList);
                  this.saveAcceptedStockIndexDb(closedStockInfoOverviewList);
                  resolve(true);
                }
              })
            }
          })
        }
      })
    });
    return promise;
  }
  // indexdb ----------------------------------------------------------------------

  getOpenStockIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      //delete from order header
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStockInfoHeader', 'readwrite');
        let store = tx.objectStore('OWS_tblStockInfoHeader');
        store.getAll().then((res: any) => {
          resolve(res);
        })
      });
    });
    return promise;
  }

  saveOpenStockHeaderIndexDb(list: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStockInfoHeader', 'readwrite');
        let store = tx.objectStore('OWS_tblStockInfoHeader');

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        list.forEach((s: any) => {
          store.get(s.shipBeginEndStockHeaderTemp.shipBeginEndStockHeaderID).then((res: any) => {
            if (res == null) {
              try {
                s.shipBeginEndStockHeaderTemp.lastSavedHash = this.getDetailListHash(s.shipBeginEndStockDetailTempList, s.shipBeginEndStockHeaderTemp);
                s.shipBeginEndStockHeaderTemp.isChangedLastSave = false;
                let req = store.add(s.shipBeginEndStockHeaderTemp);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
          });
        })

        resolve(true);
      });
    });

    return promise;
  }

  private getDetailListHash(detailList: any[], header: any) {
    // recreate object to make sure only relevant data are part of hash
    let newDetailList: any[] = [];

    detailList.forEach(detail => {
      newDetailList.push({
        suppliersProductsID: detail.suppliersProductsID,
        quantity: detail.quantity,
        remarks: detail.remarks ?? '',
      })
    });

    newDetailList.sort((a, b) => a.suppliersProductsID - b.suppliersProductsID);

    let newHashObject = {
      newUnlistedItems: header.unlistedItems ?? '',
      newDetailList: newDetailList
    }

    return objectHash(newHashObject);
  }

  saveOpenStockDetailIndexDb(list: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStockDetailList', 'readwrite');
        let store = tx.objectStore('OWS_tblStockDetailList');

        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        list.forEach((s: any) => {
          let o = {
            stockDetailID: s.shipBeginEndStockHeaderTemp.shipBeginEndStockHeaderID,
            stockDetailList: s.shipBeginEndStockDetailTempList,
          }
          store.get(o.stockDetailID).then((res: any) => {
            if (res == null) {
              try {
                let req = store.add(o);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
          });
        })

        resolve(true);
      });
    });

    return promise;
  }

  getSubmittedStockIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      //delete from order header
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStocksOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblStocksOverviewSubmitted');
        store.getAll().then((res: any) => {
          resolve(res);
        })
      });
    });
    return promise;
  }

  getAcceptedStockIndexDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      //delete from order header
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStocksOverviewAccepted', 'readwrite');
        let store = tx.objectStore('OWS_tblStocksOverviewAccepted');
        store.getAll().then((res: any) => {
          resolve(res);
        })
      });
    });
    return promise;
  }

  saveSubmittedStockIndexDb(list: any) {
    //delete from order header
    this.dbxService.openDatabase().then(db => {
      let tx = db.transaction('OWS_tblStocksOverviewSubmitted', 'readwrite');
      let store = tx.objectStore('OWS_tblStocksOverviewSubmitted');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      list.forEach((s: any) => {
        store.get(s.shipBeginEndStockHeaderID).then((res: any) => {
          if (res == null) {
            try {
              store.add(s);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }
          } else {
            if (res.isUpdatedOffline == null || res.isUpdatedOffline == false) {
              try {
                store.put(s);
              } catch (e: any) {
                if (e?.name === 'QuotaExceededError') {
                  this.handleQuotaExceeded();
                }
              }
            }
          }
        })
      })
    })
  }

  saveAcceptedStockIndexDb(list: any) {
    //delete from order header
    this.dbxService.openDatabase().then(db => {
      let tx = db.transaction('OWS_tblStocksOverviewAccepted', 'readwrite');
      let store = tx.objectStore('OWS_tblStocksOverviewAccepted');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.clear();
      try {
        list.forEach((s: any) => {
          store.add(s);
        })
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }

  cancelStockIndexDb(shipBeginEndStockHeaderID: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      //delete from order header
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStockInfoHeader', 'readwrite');
        let store = tx.objectStore('OWS_tblStockInfoHeader');
        store.delete(shipBeginEndStockHeaderID);
      });

      //delete from order detail
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblStockDetailList', 'readwrite');
        let store = tx.objectStore('OWS_tblStockDetailList');
        store.delete(shipBeginEndStockHeaderID);
      });

      resolve(shipBeginEndStockHeaderID);
    });
    return promise;
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
